// Parallel HubSpot Forms API submission for the Knife Services signup
// form (id: KnifeServicesForm, snippets/signup-form.liquid, rendered on
// sections/knife-sharpening.liquid). Its own dedicated HubSpot form
// rather than sharing one with the 7 city "Equipment Contact" pages
// (assets/locations-forms-hubspot.js) -- per the requester, kept as
// three separate groups: Locations, Parts & Service, and this one.
(function () {
  // Routed through the same-origin form relay (Shopify App Proxy ->
  // nella-app-proxy -> Linen Plus Middleware -> HubSpot), not a direct
  // client-side call to api.hsforms.com -- confirmed blocked by ad
  // blockers/tracking protection on a real visitor's browser. See
  // docs/testing/form-relay-strategy.html.
  const RELAY_URL = '/apps/nella-app-login/forms/knife_sharpening';
  const FORM_TOKEN_URL = '/apps/nella-app-login/forms-token';

  const formEl = document.getElementById('KnifeServicesForm');
  if (!formEl) return;
  if (formEl.dataset.hubspotWired) return;
  formEl.dataset.hubspotWired = 'true';

  // This form has one combined "Name" field -- same rationale and same
  // first-space split as every other HubSpot integration in this project.
  function splitName(fullName) {
    const trimmed = (fullName || '').trim().replace(/\s+/g, ' ');
    if (!trimmed) return { firstName: '', lastName: '' };
    const spaceIndex = trimmed.indexOf(' ');
    if (spaceIndex === -1) return { firstName: trimmed, lastName: '' };
    return { firstName: trimmed.slice(0, spaceIndex), lastName: trimmed.slice(spaceIndex + 1) };
  }

  function buildHubSpotFields() {
    const fields = [];
    const push = (name, value) => {
      const v = (value ?? '').toString().trim();
      if (v) fields.push({ name, value: v });
    };
    const byId = (id) => (document.getElementById(id)?.value || '').toString().trim();
    const { firstName, lastName } = splitName(byId('ContactForm-name'));

    push('email', byId('ContactForm-email'));
    push('firstname', firstName);
    push('lastname', lastName);
    push('phone', byId('ContactForm-phone'));
    push('company', byId('ContactForm-business-name'));
    // The input's real id is ContactForm-business-address -- its own
    // <label for="ContactForm-address"> doesn't match it (a pre-existing
    // markup bug in snippets/signup-form.liquid, not introduced here, and
    // not fixed here since it's unrelated to this integration).
    push('address', byId('ContactForm-business-address'));
    push('inquiry_source', 'Knife Sharpening');

    return fields;
  }

  // Fetched up front and refreshed periodically, not at submit time: this
  // native form navigates away immediately on submit (no preventDefault
  // below), which tears down this script's JS context before a token
  // fetched right then could reliably resolve -- `keepalive` only protects
  // an already-sent request, not a `.then()` waiting to send a second one
  // after it. A pre-fetched token keeps submit time down to that one
  // keepalive request.
  const FORM_TOKEN_REFRESH_MS = 5 * 60 * 1000; // server TTL is 10 min; refresh with margin
  let cachedFormToken = null;

  function fetchFormToken() {
    return fetch(FORM_TOKEN_URL)
      .then((r) => r.json())
      .then((data) => (data && data.token) || null)
      .catch(() => null);
  }

  function refreshFormToken() {
    fetchFormToken().then((token) => { cachedFormToken = token; });
  }

  refreshFormToken();
  setInterval(refreshFormToken, FORM_TOKEN_REFRESH_MS);

  function submitToHubSpot() {
    try {
      const payload = {
        fields: buildHubSpotFields(),
        pageUri: window.location.href,
        pageName: document.title,
      };
      fetch(RELAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, formToken: cachedFormToken }),
        keepalive: true,
      }).catch((err) => console.warn('HubSpot relay failed (Shopify submission is unaffected):', err));
    } catch (err) {
      console.warn('HubSpot relay failed (Shopify submission is unaffected):', err);
    }
  }

  formEl.addEventListener('submit', () => {
    submitToHubSpot();
  });
})();
